import React, { useMemo } from 'react';
import { FEED_CHIP } from './investigation/feedCardStyles';
import { collectDetailEntries, formatDetailScalar } from '../utils/feedInspectDetails';
import { resolveInspectUrl } from '../utils/feedInspectUtils';
import InspectDrawerShell from './InspectDrawerShell';

function Section({ title, children }) {
  if (!children) return null;
  return (
    <section className="rounded-xl border border-white/10 bg-slate-900/60 p-3">
      <h4 className="text-[10px] font-black uppercase tracking-[0.18em] text-slate-400">{title}</h4>
      <div className="mt-2 space-y-2 text-sm text-slate-200">{children}</div>
    </section>
  );
}

/**
 * WHOIS Intel inspect — right slide-over drawer.
 *
 * @param {{ isOpen: boolean, onClose: Function, data?: object }} props
 */
export default function WhoisInspectModal({ isOpen, onClose, data }) {
  const details = data?.details && typeof data.details === 'object' ? data.details : {};
  const entries = useMemo(() => collectDetailEntries(details), [details]);
  const scalarEntries = entries.filter((row) => row.kind === 'scalar');
  const arrayEntries = entries.filter((row) => row.kind === 'array');

  if (!isOpen || !data) return null;

  const domain = String(data.domain || details.domain || '').trim();
  const title = String(data.title || `WHOIS overview for ${domain}`).trim();
  const sourceUrl = resolveInspectUrl(data);

  return (
    <InspectDrawerShell
      isOpen={isOpen}
      onClose={onClose}
      ariaLabel="WHOIS inspection"
      testId="whois-inspect-modal"
      eyebrow="WHOIS Intel"
      title={title}
      sourceHref={sourceUrl}
      subtitle={
        domain ? <p className="mt-1 font-mono text-xs text-slate-400">{domain}</p> : null
      }
    >
      {data.snippet ? (
        <Section title="Summary">
          <p className="text-slate-300">{data.snippet}</p>
        </Section>
      ) : null}

      {sourceUrl ? (
        <p className="break-all font-mono text-[10px] text-slate-500">{sourceUrl}</p>
      ) : null}

      {scalarEntries.length > 0 ? (
        <Section title="Registration">
          <dl className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {scalarEntries.map((row) => (
              <div key={row.key} className="rounded-lg border border-white/5 bg-slate-950/70 p-2">
                <dt className="text-[9px] font-black uppercase tracking-wider text-slate-500">
                  {row.label}
                </dt>
                <dd className="mt-1 break-all font-mono text-[11px] text-slate-200">
                  {formatDetailScalar(row.value)}
                </dd>
              </div>
            ))}
          </dl>
        </Section>
      ) : null}

      {arrayEntries.map((row) => (
        <Section key={row.key} title={row.label}>
          <div className="flex flex-wrap gap-1">
            {row.value.map((item) => (
              <span key={String(item)} className={FEED_CHIP}>
                {String(item)}
              </span>
            ))}
          </div>
        </Section>
      ))}
    </InspectDrawerShell>
  );
}
